import React from "react";
import {
  DatePicker,
  DayOfWeek,
  Dropdown,
  IDropdownOption,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "office-ui-fabric-react";
import { IDataCenter, ISensorReadingCount } from "../../vm";
import { ToastContext } from "../common/ToastProvider";
import moment from "moment";
import { getSensorReadingsCount } from "../../services/dashboard/DashboardService";
import { childrenGap } from "../common/Constants";
import ReportStatusCard from "./ReportStatusCard";
import { ResponsiveBar } from "@nivo/bar";

export interface SensorReadingDashboardProps {
  datacenters: IDataCenter[];
}
const wrapperStyles = {
  // width: "100%",
  // maxWidth: 980,
  margin: "0 auto",
};

const SENSOR_DIC: { [Key: string]: string } = {
  schneider: "Schneider",
  "delta-snmp": "Delta SNMP",
  siemens: "Siemens",
  tridium: "Tridium",
  "ganesh-computer": "Ganesh Computer",
  "ebi-excel": "Ebi Excel",
  "delta-pg": "Delta PG",
  datson: "Datson",
  vertiv: "Vertiv",
  azbil: "Azbil",
};

const SensorReadingDashboard: React.FC<SensorReadingDashboardProps> = ({
  datacenters,
}) => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    sensorReadingCount: {
      pdu: [],
      tempRh: [],
    },
    searchObj: {
      date: new Date(),
      datacenterId: datacenters.length > 0 ? datacenters[0]._id : "",
    },
    datacenterOptions: [],
    selectedDatacenter: datacenters.length > 0 ? datacenters[0]._id : "",
  } as {
    isLoading: boolean;
    sensorReadingCount: ISensorReadingCount;
    searchObj: {
      date: Date | string;
      datacenterId: string;
    };
    datacenterOptions: IDropdownOption[];
    selectedDatacenter: string;
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getSensorReadingCount();
    };
    asyncFunc();
  }, []);

  const getSensorReadingCount = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let searchObj = { ...localState.searchObj };
    searchObj.date = moment(searchObj.date).format("YYYY-MM-DD");

    let result = await getSensorReadingsCount(searchObj);
    if (result?.success) {
      let datacenterOptions: IDropdownOption[] = [];
      if (datacenters.length > 0) {
        datacenters.forEach((d) => {
          datacenterOptions.push({
            key: d._id as string,
            text: d.name,
          });
        });
      }

      setState({
        ...localState,
        sensorReadingCount: result.data,
        datacenterOptions,
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(
        result?.message || "Error while getting sensor reading count",
        "error"
      );
    }
  };

  return (
    <React.Fragment>
      {/* {state.isLoading && <Loading />} */}
      <div style={wrapperStyles}>
        <div className="ms-Grid p-0">
          <div className="ms-Grid-row ms-motion-scaleDownIn status-count-card overflow ml-0 mr-0">
            {state.isLoading && (
              <div className="custom-card spinner-center">
                <Spinner
                  size={SpinnerSize.large}
                // label="Loading"
                // labelPosition="bottom"
                />
              </div>
            )}
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
              <Stack
                horizontal
                horizontalAlign="space-between"
                wrap
                tokens={childrenGap}
              >
                <Stack.Item>
                  <Text className="dashboard-card-title">
                    Sensors With No Readings
                  </Text>
                </Stack.Item>
                <Stack.Item>
                  <Stack horizontal wrap tokens={childrenGap}>
                    <Stack.Item>
                      <Dropdown
                        selectedKey={state.selectedDatacenter}
                        styles={{ dropdown: { width: 200 } }}
                        options={state.datacenterOptions}
                        onChange={async (e, v: IDropdownOption | undefined) => {
                          if (v) {
                            let obj = {
                              ...state,
                              selectedDatacenter: v.key as string,
                              searchObj: {
                                ...state.searchObj,
                                datacenterId: v.key as string,
                              },
                            };
                            // setState();
                            await getSensorReadingCount(obj as any);
                          }
                        }}
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <DatePicker
                        firstDayOfWeek={DayOfWeek.Sunday}
                        showMonthPickerAsOverlay={true}
                        value={new Date(state.searchObj.date)}
                        showGoToToday={false}
                        onSelectDate={async (date: Date | null | undefined) => {
                          let obj = {
                            ...state,
                            searchObj: {
                              ...state.searchObj,
                              date: date as Date,
                            },
                          };
                          await getSensorReadingCount(obj as any);
                        }}
                        styles={{ root: { width: 200 } }}
                      />
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
              </Stack>
              <hr />
              {state.sensorReadingCount.pdu.length > 0 ||
                state.sensorReadingCount.tempRh.length > 0 ? (
                <div className="ms-Grid-row">
                  {state.sensorReadingCount.pdu.length > 0 && (
                    <div
                      className={`ms-Grid-col pt-0 ${state.sensorReadingCount.tempRh.length > 0
                          ? `ms-sm12 ms-md12 ms-lg6`
                          : `ms-sm12 ms-md12 ms-lg12`
                        }`}
                    >
                      <fieldset>
                        <legend>PDU</legend>
                        <div className="ms-Grid-row">
                          {state.sensorReadingCount.pdu.map((item, index) => (
                            <div
                              className={`ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6`}
                              key={index}
                            >
                              {/* <div
                            onClick={() =>
                              index === 3
                                ? undefined
                                : viewMomStatusDetails(item)
                            }
                            //   className={`${index === 3 ? "" : "pointer"}`}
                          > */}
                              <ReportStatusCard
                                status={item.systemType}
                                count={item.count}
                                isReportStatus={false}
                                isMomStatus={false}
                                isSlaMatrix={false}
                              />
                            </div>
                            // </div>
                          ))}
                        </div>
                      </fieldset>
                    </div>
                  )}
                  {state.sensorReadingCount.tempRh.length > 0 && (
                    <div
                      className={`ms-Grid-col pt-0 ${state.sensorReadingCount.pdu.length > 0
                          ? `ms-sm12 ms-md12 ms-lg6`
                          : `ms-sm12 ms-md12 ms-lg12`
                        }`}
                    >
                      <fieldset>
                        <legend>TEMP & RH</legend>
                        <div className="ms-Grid-row">
                          {state.sensorReadingCount.tempRh.map(
                            (item, index) => (
                              <div
                                className={`ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6`}
                                key={index}
                              >
                                {/* <div
                            onClick={() =>
                              index === 3
                                ? undefined
                                : viewMomStatusDetails(item)
                            }
                            //   className={`${index === 3 ? "" : "pointer"}`}
                          > */}
                                <ReportStatusCard
                                  status={item.systemType}
                                  count={item.count}
                                  isReportStatus={false}
                                  isMomStatus={false}
                                  isSlaMatrix={false}
                                />
                              </div>
                              // </div>
                            )
                          )}
                        </div>
                      </fieldset>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <br />
                  <Text>No Data Found</Text>
                  <br />
                  <br />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SensorReadingDashboard;
